import React from "react";
import Contact from "../Components/contact/Contact";
import TopBar from "../Components/common/TopBar";
import Spacer2 from "../Components/common/Spacer2";

function ContactPage() {
  return (
    <>
      <TopBar />
      <Spacer2 />
      <Contact />
    </>
  );
}

export default ContactPage;
